import { faTrophy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function About() {
    return (
        <div className="container">
            <h1 className="text-center">
                BEST IT TRAINING IN THE COUNTRY
            </h1>
            <h4 className="text-center">
                Learn real world development and skills from experts
            </h4>
            <div className="row mt-5">
                <div className="col-6">
                    <h5>
                        <FontAwesomeIcon icon={faTrophy} className="p-1 text-warning border rounded-circle" />
                        Develop real world project
                    </h5>
                    <p>
                        As a developer everyone should take the challenge of developing real world project. Before applying in any job it would be more beneficial. Our community will make you develop real world project
                    </p>
                </div>
                <div className="col-6">
                    <h5>
                        <FontAwesomeIcon icon={faTrophy} className="p-1 text-warning border rounded-circle" />
                        Build Foundation
                    </h5>
                    <p>
                        Build a solid foundation from our community
                    </p>
                </div>
            </div>
            <div className="bg-info">
                <h3 className="p-5 text-center">
                    Are you ready to explore us?
                </h3>

            </div>
        </div>
    )
}
